const PureCloud = {
    install(Vue, options) {

        var provAxios = axios.create({
            baseURL: 'https://api.mypurecloud.com/api/v2',
        });

        provAxios.interceptors.response.use( response => {
            return response;
        }, error => {
            if( error.response) {
                if(error.response.status === 401) {
                    //auth.redirect();
                    console.log('Reauth PureCloud');
                }
            }
            return Promise.reject(error);
        });

        provAxios.interceptors.request.use((config) => {
            console.log(config);
            config.headers['Authorization'] = 'Bearer ' + auth.getToken();
            return config;
        });


        delete provAxios.defaults.headers.common['X-CSRF-TOKEN'];
        
        var auth = new Vue({
            data() {
                return {
                    providerUser: {},
                    token: false
                }
            },
            methods: {
                get_user: function() {
                    if(typeof(this.providerUser.id) !== 'undefined') return;

                    provAxios.get('/users/me').then(response => {
                        auth.providerUser = response.data;
                    });

                    /*provAxios.get('/flows?type=inboundcall').then(response => {
                        if( typeof( response.data.entities ) === 'undefined' ) {
                            return;
                        }

                        for( var i = 0; i < response.data.entities.length; i++ ) {
                            provAxios.get('/flows/' + response.data.entities[i].id).then(resp => {
                                console.log(resp);
                            })
                        }
                    });*/
                },
                setToken: function(token, expiration) {
                    localStorage.setItem('provider_token', token);
                    localStorage.setItem('provider_expiration', expiration);
                    provAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
                    this.token = token;
                    //this.get_user();
                },
                getToken: function() {
                    var token = localStorage.getItem('provider_token');
                    var expiration = localStorage.getItem('provider_expiration');

                    

                    if( ! token || ! expiration ) {
                        return false;
                    }

                    if(Date.now() > parseInt(expiration) ) {
                        console.log(token + ' : ' + expiration);
                        console.log('PROVIDER EXPIRED');
                        this.destroyToken();
                        return false;
                    } else {
                        return this.token = token;
                    }
                },
                destroyToken: function() {
                    this.providerUser = {};
                    this.token = false;
                    localStorage.removeItem('provider_token');
                    localStorage.removeItem('provider_expiration');
                },
                redirect: function() {
                    options.push('/login');
                },
                isAuthenticated: function() {
                    console.log('TOKEN: ' + this.getToken());
                    return this.getToken();
                }
            }
        });

        Vue.mixin({
            computed: {
                providerAuthenticated: function() {
                    return auth.token;
                },
                providerUser: function() {
                    return auth.providerUser;
                }
            }
        });

        if(auth.getToken()) {
           provAxios.defaults.headers.common['Authorization'] = 'Bearer ' + auth.getToken();
            console.log('SETTING PROVIDER AUTH DEFAULTS');
            if( typeof( auth.providerUser.id ) === 'undefined' ) auth.get_user();
        }
        Vue.prototype.$provider = Vue.provider = auth;
    }
}

export default PureCloud;


//////////////////
// WEBPACK FOOTER
// ./prompts/packages/provider/PureCloud.js
// module id = null
// module chunks = 